import 'jquery';
import { getCssVar, setCssVar } from './cssVars';

export const viewportSize = ({type = 'inner'} = {}) => {
  let w = window;
  let prefix = type;
  if (!(`${prefix}Width` in window)) {
    w = document.documentElement || document.body;
    prefix = 'client';
  }
  return {
    width: w[`${prefix}Width`],
    height: w[`${prefix}Height`],
    ratio: w[`${prefix}Height`] / w[`${prefix}Width`],
  };
};

export const viewportInner = () => viewportSize({type: 'inner'});
export const viewportOuter = () => viewportSize({type: 'outer'});

export const getFullheightOffset = (
  elements = {
    header: $('.banner'),
    bar_top: $('.bar-top'),
    cookie_bar: $('#cookie-notice'),
  }
) => {
  let offset = 0;

  if (
    elements.header &&
    'fixed' !== elements.header.css('position') &&
    !elements.header.get(0).className.match(/\bfixed/)
  ) {
    offset = parseFloat(elements.header.outerHeight(true), 10);
    offset += parseFloat(elements.header.css('border-top-width'), 10);
    if (elements.bar_top && elements.bar_top.length) {
      offset += parseFloat(elements.bar_top.outerHeight(true), 10);
    }
  }

  const $body = $('body');
  if ($body.hasClass('passpartout')) {
    offset += parseFloat($body.css('border-top-width'), 10);
    offset += parseFloat($body.css('border-bottom-width'), 10);
  }

  if (elements.cookie_bar && elements.cookie_bar.length) {
    const cookieBarHeight = parseFloat(elements.cookie_bar.outerHeight(true), 10);
    setCssVar('--cookie-bar-height', cookieBarHeight + 'px');
    offset += parseFloat(cookieBarHeight, 10);
  }

  if (!getCssVar('--fullheight-offset')) {
    setFullheightOffset(offset);
  }

  return offset;
};

export const setFullheightOffset = offset => {
  setCssVar('--fullheight-offset', offset + 'px');
};

export default {
  getFullheightOffset,
  setFullheightOffset,
  viewportSize,
};



// WEBPACK FOOTER //
// /Users/dcsturm/wrk/packages/composer/zd-wp-sage-lib/resources/assets/scripts/util/viewport.js